export default {
	// SERVER_URL: "http://localhost:9000",
	SERVER_URL: "https://admin.matchdaydigital.com",
	ONESIGNAL_APP_ID: "32281f23-0b18-48fb-82d0-41924c04fcf6",
	STRIPE_KEY: "pk_test_51GuKqgHg9TdUEpMOM72OC7jcbU4qNsc3ZexvPGpnnDlNhbmcJ2Ebs0cf7UlvxfZCG4GAedYu8LCZoRzAACUmYxfg00tb5exshL",
}